var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckInColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12548_4405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31009 6.7767C7.95216 6.7767 9.28754 5.44132 9.28754 3.79925V3.30301C9.28754 1.66095 7.95216 0.325562 6.31009 0.325562C4.66803 0.325562 3.33264 1.66095 3.33264 3.30301V3.79925C3.33264 5.44132 4.66803 6.7767 6.31009 6.7767Z",
    fill: "#FADB5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94279 8.25644C7.60847 7.60983 5.01064 7.60983 2.67582 8.25644C1.60146 8.55418 0.850647 9.53823 0.850647 10.6503V12.2358H11.768V10.6503C11.768 9.53823 11.0172 8.55418 9.94279 8.25644Z",
    fill: "#FADB5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12548_4405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.850647 0.325562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckInColored);
export default __webpack_public_path__ + "static/media/icon-check-in-colored.20a7b4d4.svg";
export { ForwardRef as ReactComponent };